import React, { createContext, useContext } from "react";

const PortalChromeContext = createContext({
  composerActive: false,
  setComposerActive: () => {},
});

export function usePortalChrome() {
  return useContext(PortalChromeContext);
}

export { PortalChromeContext };
